import { formatCents } from "../../../utils/directorFormat";

const labelFor = (item) => item.weekStart || item.competence || item.periodKey || "Período";

const FlowBars = ({ items = [], valueKey = "netFlowCents", onSelect }) => {
  const values = items.map((item) => Number.isSafeInteger(item[valueKey]) ? item[valueKey] : null);
  const maximum = Math.max(1, ...values.filter(value => value !== null).map((value) => Math.abs(value)));
  return <div className="director-module1__bars" role="list" aria-label="Fluxo por período">
    {items.map((item, index) => {
      const value = values[index];
      const tone = value < 0 ? "pressure" : value > 0 ? "positive" : "zero";
      const style = { "--bar-size": `${Math.max(8, Math.round(Math.abs(value) * 100 / maximum))}%` };
      const ariaLabel = `${labelFor(item)} · ${formatCents(value)}`;
      const content = <>
        <span className="director-module1__bar-track">{value === null ? <small>Indisponível</small> : <i data-tone={tone} style={style} />}</span>
        <small>{labelFor(item)}</small>
      </>;
      return onSelect
        ? <button type="button" role="listitem" key={labelFor(item)} onClick={() => onSelect(item)} title={ariaLabel} aria-label={ariaLabel}>{content}</button>
        : <div role="listitem" key={labelFor(item)} title={ariaLabel} aria-label={ariaLabel}>{content}</div>;
    })}
  </div>;
};

export default FlowBars;
